import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-icon-option',
  templateUrl: './dropdown-icon-option.component.html',
  styleUrls: ['./dropdown-icon-option.component.css', '../../../../../assets/css/new-buttons-theme.css']
})
export class DropdownIconOptionComponent implements OnInit {


  @Input() dropdownIcon: string;
  @Input() dropdownLabel: string;
  @Input() label: string;
  @Input() value: string;
  @Output() optionSelectedValue = new EventEmitter<string>();

  @Input() options: Array<{
    value: number,
    name: string,
    cssClass: string,
    isIcon: boolean,
    iconPath?: string,
    iconAlt?: string
  }>;

  constructor() { }

  ngOnInit() {
  }

  optionSelected(option: string) {
    this.optionSelectedValue.emit(option);
  }
}
